import React, { Component } from "react"
import styled from "@emotion/styled"
import { colors, typography, animations } from "src/styles"
import Link from "src/components/Link"
import { MdArrowForward } from "react-icons/md"

const StyledLink = styled.span`
  ${typography.h6}
  position: relative;
  display: inline-block;
  color: ${({ theme }) => colors[theme]};
  &:after {
    content: "";
    display: block;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    height: 2px;
    background: ${({ theme }) => colors[theme] || "var(--main-color)"};
    transform: scaleX(0);
    transform-origin: right center;
    transition: transform ${animations.mediumSpeed} ease-in-out;
  }
  &:hover {
    &:after {
      transform-origin: left center;
      transform: scaleX(1);
    }
  }
`

const ExternalLinkIcon = styled(MdArrowForward)`
  vertical-align: middle;
  transform: rotate(-45deg);
  margin-left: 0.3em;
  margin-right: -4px;
`

class TextLink extends Component {
  render() {
    const {
      to,
      external,
      target,
      loading,
      error,
      success,
      disabled,
      onClick,
      setTheme,
      className,
      children,
      as = Link,
      title,
    } = this.props

    const x = external && !to?.includes("koalafi.com")

    return (
      <StyledLink
        className={"button " + className}
        to={to}
        target={target}
        external={external}
        loading={loading}
        error={error}
        success={success}
        disabled={disabled}
        onClick={onClick}
        theme={setTheme}
        title={title}
        as={as}
      >
        {children}
        {x && <ExternalLinkIcon size={18} />}
      </StyledLink>
    )
  }
}

export default TextLink
